/**
 * 权限管理服务
 */

import { httpClient } from './httpClient';
import { API_ENDPOINTS } from './api/config';

export const permissionService = {
  // 获取用户角色
  async getUserRoles(userId: number) {
    return httpClient.get(`${API_ENDPOINTS.PERMISSION.USER_ROLES}/${userId}`);
  },

  // 获取用户角色ID列表
  async getUserRoleIds(userId: number) {
    return httpClient.get(`${API_ENDPOINTS.PERMISSION.USER_ROLE_IDS}/${userId}`);
  },

  // 获取角色菜单
  async getRoleMenus(roleId: number) {
    return httpClient.get(`${API_ENDPOINTS.PERMISSION.ROLE_MENUS}/${roleId}`);
  },

  // 分配用户角色
  async assignUserRoles(userId: number, roleIds: number[]) {
    return httpClient.post(API_ENDPOINTS.PERMISSION.ASSIGN_USER_ROLES, {
      userId,
      roleIds
    });
  },

  // 分配角色菜单
  async assignRoleMenus(roleId: number, menuIds: number[]) {
    return httpClient.post(API_ENDPOINTS.PERMISSION.ASSIGN_ROLE_MENUS, {
      roleId,
      menuIds
    });
  },

  // 检查权限
  async checkPermission(permission: string) {
    return httpClient.get(`${API_ENDPOINTS.PERMISSION.CHECK_PERMISSION}?permission=${permission}`);
  },

  // 获取用户菜单树（根据用户权限）
  async getUserMenus() {
    return httpClient.get('/api/sys/permission/user-menus');
  }
};

export default permissionService;
